import type { AnyAction, Dispatch } from 'redux';
// @ts-ignore
import { BEGIN, COMMIT, REVERT } from 'redux-optimist';

import { type ObjectValuesUnionType } from '../../utils/typing';

export const FavoriteActionTypes = Object.freeze({
  ADD: 'FAVORITE:ADD',
  ADD_OK: 'FAVORITE:ADD_OK',
  ADD_KO: 'FAVORITE:ADD_KO',
  DEL: 'FAVORITE:DEL',
  DEL_OK: 'FAVORITE:DEL_OK',
  DEL_KO: 'FAVORITE:DEL_KO',
  PURGE: 'FAVORITE:PURGE',
  PURGE_OK: 'FAVORITE:PURGE_OK',
  PURGE_KO: 'FAVORITE:PURGE_KO',
  RECEIVE_RESPONSE: 'FAVORITE:RECEIVE_RESPONSE',
  RECEIVE: 'FAVORITE:RECEIVE',
});
export type FavoriteActionType = ObjectValuesUnionType<typeof FavoriteActionTypes>;

export type OptimistActionType = typeof BEGIN | typeof COMMIT | typeof REVERT;

export type PayloadReceiveResponse = {
  id: string;
  result: { success: boolean };
};

export type ReceiveResponseActionPayload = {
  type: FavoriteActionType;
  payload: PayloadReceiveResponse;
};
export type ReceiveResponseAction = (payload: PayloadReceiveResponse) => ReceiveResponseActionPayload;

export type DoPurgeFavoritesAction = () => Dispatch<AnyAction>;

export type FavoritesOptimistNoPayloadAction = ({ transactionId }: { transactionId: string }) => {
  type: FavoriteActionType;
  optimist: { type: OptimistActionType; id: string };
};

export type SetFavoritesDispatchAction = ({ matchId }: { matchId: number }) => (dispatch: Dispatch<AnyAction>) => void;

type Optimist = {
  type: OptimistActionType;
  id: string;
};
export type FavoritesOptimistActionPayload = {
  type: FavoriteActionType;
  payload: { matchId: number };
  optimist: Optimist;
};

export type FavoritesOptimistAction = ({
  transactionId,
  matchId,
}: {
  transactionId: string;
  matchId: number;
}) => FavoritesOptimistActionPayload;

export type SetFavoritesAction = (matchIds: Array<number>) => {
  type: FavoriteActionType;
  payload: {
    matchIds: Array<number>;
  };
};
